import {
  CarrierCostType,
  ProfitType,
} from 'pages/QuoteView/Quoting/RequestQuickQuote/types';

import { Suggestion } from '../types';

export type ApplyResult = {
  carrierCost: number;
  carrierCostType: CarrierCostType;
  profit: number;
  profitType: ProfitType;
};

// Maps a Coach suggestion into Quick Quote calculator inputs (flat buy + margin).
export function applySuggestion(suggestion: Suggestion): ApplyResult {
  const result: ApplyResult = {
    carrierCost: Math.round(suggestion.targetBuy),
    carrierCostType: CarrierCostType.Flat,
    profit: suggestion.suggestedMargin,
    profitType: suggestion.suggestedMarginType ?? ProfitType.Percentage,
  };
  return result;
}
